// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import Alert from "@dip/helsecore/src/components/parts/Alert/Alert";
import type { AlertProps } from '@dip/helsecore/src/components/parts/Alert/Alert';

export default (props: Readonly<AlertProps>) => <Alert {...props} />
